import { useToast } from "@agney/ir-toast";
import {
  IonButton,
  IonIcon,
  IonItem,
  IonLabel,
  IonModal,
  IonSelect,
  IonSelectOption,
  IonTextarea,
} from "@ionic/react";
import React, { useEffect, useState } from "react";
import { utilService } from "../../services";
import { useTranslation } from "react-i18next";
import "./GlobalSpecialitySearch.scss";
import Loader from "../../components/Shared/Loader/Loader";
import { closeCircleOutline } from "ionicons/icons";
import { globalSearchService } from "../GlobalSearch/GlobalSearch.service";
import InfiniteScroll from "react-infinite-scroll-component";
import DoctorList from "../../components/Shared/DoctorList/doctor-list";
import { CONSTANTS } from "../../constants";
import { rolePermissionsService } from "../../services/rolePermissions.service";
import _ from "lodash";
import moment from "moment";
import { globalSpecialityService } from "./GlobalSpeciality.service";
import NoResults from "../../components/Shared/NoResults/NoResultsComponent";

interface Props {
  searchInput: string;
  isModalPopUpScreen?: boolean;
}

const GlobalSpecialitySearch: React.FC<any> = (props: Props) => {
  const [userListData, setUserListData]: any = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [apiParams, setApiParams]: any = useState({});
  const [rolePermissions, setRolePermissions] = useState<any>(Object);
  const [selectedDoctorList, setSelectedDoctorList]: any = useState([]);
  const [showFavBtn, setShowFavBtn]: any = useState(false);
  const [selectedUserGuid, setSelectedUserGuid]: any = useState();
  const [addedToFavorite, setToFavorite]: any = useState(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [titleName, setTitleName] = useState<string>("");
  var [isInputEmpty, setIsInputEmpty] = useState(true);
  const [pageNo, setPageNo] = useState(1);
  const [designation, setDesignation] = useState<string>("");
  const [sortByList, setSortByList]: any = useState([]);
  const [selectedSortId, setSelectedSortId]: any = useState("");
  const [hasMoreItems, setHasMoreItems] = useState(true);

  const Toast = useToast();
  const { t } = useTranslation("messages");
  const { t: tSettings } = useTranslation("settings");

  useEffect(() => {
    fetchUsersResult(props?.searchInput,1);
  }, [props?.searchInput, selectedSortId]);

  useEffect(() => {
    setPageNo(1);
    fetchUsersResult(props?.searchInput,1);
  }, [selectedSortId]);

  useEffect(() => {
    const rolePermissionData =
      rolePermissionsService.getRolePermissionsDetails();
    setRolePermissions(rolePermissionData);
    getAndBindSpecialityList();
  }, []);

  let doctorListMessage = {
    componentName: CONSTANTS.COMPONENTS.FILE_SHARE,
    isMultiSelectEnabled: false,
    isShowColorBadge: false,
  };

  async function getAndBindSpecialityList() {
    if (pageNo === 1) {
      setShowLoader(true);
    }
    const params = setParams(props?.searchInput,pageNo);
    const respMessageListResult =
      await globalSpecialityService.getSpecialityList(params);
    if (respMessageListResult.isSuccess && respMessageListResult.result) {
      if (pageNo === 1) {
        setSortByList(respMessageListResult?.result);
      } else {
        setSortByList([...sortByList, ...respMessageListResult?.result]);
      }
    }
    setShowLoader(false);
  }

  //fetching user result for speciality search
  async function fetchUsersResult(searchedName: string,page?:number) {
    if (page === 1) {
      setShowLoader(true);
    }
    const params = setParams(props?.searchInput,page);
    const respMessageListResult =
      await globalSpecialityService.getSpecialityUsersList(
        params,
        selectedSortId
      );
    if (respMessageListResult.isSuccess && respMessageListResult.result) {
      if (!_.isEmpty(respMessageListResult.result)) {
        if (page === 1) {
          let resultDoctorListData = [...respMessageListResult.result?.[0]?.data];
          resultDoctorListData.find((doctorcard: any) => {
            if (doctorcard.guid === selectedDoctorList[0]?.guid) {
              return (doctorcard.isSelected = true);
            }
          });
          setHasMoreItems(false);
          setUserListData(respMessageListResult.result?.[0]?.data);
        } else if (selectedDoctorList[0]?.isSelected) {
          let combinedUserListData = [
            ...userListData,
            ...respMessageListResult.result?.[0]?.data,
          ];

          combinedUserListData.find((doctorcarditem) => {
            if (doctorcarditem?.guid === selectedDoctorList[0]?.guid) {
              return (doctorcarditem.isSelected = true);
            }
          });

          setUserListData(combinedUserListData);
        } else {
          setUserListData([
            ...userListData,
            ...respMessageListResult.result?.[0]?.data,
          ]);
        }
        const hasMore = respMessageListResult.result?.[0]?.data.length > 0;
        setHasMoreItems(hasMore);

        if (respMessageListResult.result?.[0]?.next == null) {
          setPageNo(1);
          setHasMoreItems(false);
        } else {
          setPageNo(page + 1);
        }
      }else{
        setUserListData([]);
        setHasMoreItems(false);
      }
    }
    setShowLoader(false);
  }

  async function getIndiviualSpecialityList(
    searchedName: string,
    selectedSortId: number
  ) {
    const params = setParamsforIndiviualSpeciality(props?.searchInput);
    const respMessageListResult =
      await globalSpecialityService.getIndivualSpecialityList(
        params,
        selectedSortId
      );
    if (respMessageListResult.isSuccess && respMessageListResult.result) {
      if (!_.isEmpty(respMessageListResult.result)) {
        if (pageNo === 1) {
          let resultDoctorListData = [...respMessageListResult.result?.[0]?.data];
          resultDoctorListData.find((doctorcard: any) => {
            if (doctorcard.guid === selectedDoctorList[0]?.guid) {
              return (doctorcard.isSelected = true);
            }
          });
          setUserListData(respMessageListResult.result?.[0]?.data);
        } else {
          setUserListData([respMessageListResult.result?.[0]?.data]);
        }
      }
    }
    setShowLoader(false);
  }

  const setParams = (searchedText: string,page?:number) => {
    return {
      search_name: searchedText,
      page: page,
      time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      reg_code: utilService.getNetwork(),
    };
  };

  const setParamsforIndiviualSpeciality = (searchedText: string) => {
    return {
      search_name: searchedText,
      time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      reg_code: utilService.getNetwork(),
    };
  };
  const getSelectedDoctorList = (doctorList: any) => {
    if (doctorList.length !== 0) {
      setShowFavBtn(true);
      setSelectedDoctorList(doctorList);
      setSelectedUserGuid(doctorList[0].guid);
      setToFavorite(doctorList[0].addedToFavorite);
      setDesignation(doctorList[0].designation);
    }
  };

  const clearFilterBySpeciality = () => {
    setSelectedSortId("");
    setPageNo(1);
    setHasMoreItems(true);
  };

  const addUserToFavorite = () => {
    if (!addedToFavorite) {
      let params = setFavUserParams();
      addFavUsers(params);
      setShowFavBtn(false);
    } else {
      Toast.warning(CONSTANTS.MESSAGES.USER_IN_FAVORITES);
    }
  };

  const setFavUserParams = () => {
    const currentDate: any = moment().format("YYYY-MM-DD");
    const currentHour = moment().format("HH");
    const currentMinute = moment().format("mm");
    return {
      reg_code: utilService.getNetwork(),
      date: currentDate,
      guid: selectedUserGuid,
      user_guid: utilService.getLoggedUserGuid(),
      hours: currentHour,
      minutes: currentMinute,
      designation: designation,
      title_name: titleName,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
  };

  async function addFavUsers(params: any) {
    setShowLoader(true);
    const addFavUserResult = await globalSearchService.addFavoriteUsers(params);

    if (addFavUserResult.isSuccess) {
      userListData.find((doctorcarditem: any) => {
        if (doctorcarditem.guid) {
          return (doctorcarditem.isSelected = false);
        }
      });
      setShowFavBtn(false);

      Toast.success(tSettings("addedFavorite"));
    } else {
      console.log("error");
      globalSearchService.handleErrorResponse();
    }
    setShowLoader(false);
  }

  const checkIfInputEmpty = () => {
    const isWhitespace = utilService.checkIfInputEmpty("addFavText");
    setIsInputEmpty(isWhitespace);
  };

  const handleSearch = (event: any) => {
    fetchUsersResult(event.target.value);
  };

  return (
    <div className="filter-container">
      <IonItem
        lines="none"
        style={{ width: "700px" }}
        className="select-container"
      >
        <div className="item-content" style={{ width: "700px" }}>
          <IonLabel className="ion-label-cust">{t("filterBySpeciality")}</IonLabel>

          <IonSelect
            className="ion-select-custom"
            okText={t("ok")}
            cancelText={t("cancel")}
            value={selectedSortId}
            placeholder={t("selectAnySpeciality")}
            onIonChange={(e) => {
              if (e.detail.value) {
                setPageNo(1);
              }
              setSelectedSortId(e.detail.value);
            }}
            multiple={false}
          >
            {sortByList.map((item: any) => (
              <IonSelectOption value={item.id} key={item.id}>
                {item.value}
              </IonSelectOption>
            ))}
          </IonSelect>
          {selectedSortId !== undefined && selectedSortId !== "" && (
            <div
              className="cust-close-icon"
              onClick={() => {
                clearFilterBySpeciality();
              }}
            >
              <IonIcon icon={closeCircleOutline}></IonIcon>
            </div>
          )}
        </div>
      </IonItem>
     
      {!showLoader ?
      (userListData.length > 0 ? <div className="global-doctor-list-container">
        <InfiniteScroll
          dataLength={userListData.length}
          height={`73vh`}
          className="global-search-container"
          next={() => fetchUsersResult(props?.searchInput,pageNo)}
          hasMore={hasMoreItems}
          loader={
            showLoader ?
            <div className="global-speciality-loader">
              <Loader />
            </div>:
            null
          }
        >
          <DoctorList
            apiParams={apiParams}
            doctorListInputData={doctorListMessage}
            doctorListDataFromParent={userListData}
            permissions={rolePermissions}
            searchText={props?.searchInput}
            getSelectedCard={() => {}}
            getSelectedCardAndSchedule={() => {}}
            getIsAllSelectedStatus={() => {}}
            getAllCards={() => {}}
            getAllCardsAndSchedule={() => {}}
            isFullScreen={!props.isModalPopUpScreen}
            hideFeatureButtons={false}
            isFromSpecialitySearch={true}
          ></DoctorList>
        </InfiniteScroll>
      </div> : 
      <div style={{height:"80vh"}}>
          <NoResults />
        </div>
       )
      : <div className="loader-container">
          <Loader></Loader>
        </div>}

      <IonModal
        isOpen={showModal}
        backdropDismiss={false}
        className="add-global-fav-modal"
      >
        <div className="label-div">
          <div className="label-name">{t("addToFavorite")}</div>
        </div>
        <div className="title-name-container">
          <div className="title-name-label">{t("titleName")}</div>
        </div>

        <div className="add-fav-text-box">
          <IonTextarea
            className="textarea-div"
            placeholder={t("enterTitleName")}
            id="addFavText"
            value={titleName}
            onIonChange={(e) => {
              checkIfInputEmpty();
              setTitleName(e.detail.value!);
            }}
          ></IonTextarea>
        </div>

        <div className="add-fav-button-container">
          <div className="cancel-button-div">
            <IonButton
              color="medium"
              className="button secondary-btn  btn-curved"
              onClick={() => {
                setTitleName("");
              }}
            >
              {t("clear")}
            </IonButton>
          </div>
          <div className="send-button-div">
            <IonButton
              disabled={isInputEmpty}
              className="submit-btn button primary-btn btn-curved"
              onClick={() => {
                addUserToFavorite();
                setShowModal(false);
                setTitleName("");
              }}
            >
              {t("add")}
            </IonButton>
          </div>
        </div>
      </IonModal>
    </div>
  );
};

export default GlobalSpecialitySearch;
